// import { IconContext } from "react-icons";
// import { MdKeyboardArrowDown } from 'react-icons/md';
import { GetCommentListByPostIdQuery_getCommentListByPostId_comments } from "@bakbak/controller";
import { Avatar, List } from 'antd';
import * as React from 'react';
import { CreateReplyConnector } from '../../reply/create/CreateReplyConnector';
import { VoteComponent } from '../../shared/VoteComponent';
import { CommentWithReplyListConnector } from '../details/CommentWithReplyListConnector';


interface Props {
  loggedUser: any;
  comment: GetCommentListByPostIdQuery_getCommentListByPostId_comments;
  changeVote: (likeDislike: number) => void;
}

interface State {
  showReply: boolean;
};

export class CommentItemView extends React.PureComponent<Props, State> {
  state = { showReply: false };

  toggleReply = () => {
    // e.preventDefault();
    this.setState((prevState: any) => ({
      showReply: !prevState.showReply
    }));
  }

  render() {
    const { comment, loggedUser, changeVote } = this.props;
    return (
      <div style={{ marginLeft: 20 }}>
        <List.Item key={comment.id}>
          <List.Item.Meta
            avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
            title={comment.author.userName}
            description={comment.text}
          />
          <div style={{ marginLeft: 50 }}>
            <VoteComponent
              data={comment}
              loggedUser={loggedUser}
              dataVoteChange={changeVote}
            />
            <span style={{ cursor: 'pointer', marginLeft: 20 }} onClick={this.toggleReply}>REPLY</span>
          </div>
          {
            this.state.showReply &&
            <CreateReplyConnector
              commentId={comment.id}
              toggleReply={this.toggleReply}
              loggedUser={loggedUser}
            />
          }
          <CommentWithReplyListConnector commentId={comment.id} />
        </List.Item>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/comment/item/CommentItemView.tsx